import { render } from "./CampaignGroupFilterItem.vue?vue&type=template&id=27bfe256"
import script from "./CampaignGroupFilterItem.vue?vue&type=script&lang=js"
export * from "./CampaignGroupFilterItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__